import React from "react"

import "./Backdrop.scss"

type BackdropProps = {
  onClick?: () => void
  children?: React.ReactNode
}

function Backdrop({ onClick, children }: BackdropProps) {
  return (
    <div className="Backdrop" onClick={onClick}>
      {children}
    </div>
  )
}

export default Backdrop
